// Single shared RAF loop drives all marquee instances
var marqueeInstances = [];
var rafId = null;
var lastTime = null;

function tickAll(ts) {
  if (!lastTime) lastTime = ts;
  var delta = ts - lastTime;
  lastTime = ts;

  marqueeInstances.forEach(function (m) {
    if (!m.paused && m.setWidth > 0) {
      m.pos += (m.speed * delta) / 1000;
      if (m.pos >= m.setWidth) m.pos -= m.setWidth;
      m.track.style.transform = 'translateX(-' + m.pos + 'px)';
    }
  });

  rafId = requestAnimationFrame(tickAll);
}

function startLoop() {
  if (!rafId) {
    lastTime = null;
    rafId = requestAnimationFrame(tickAll);
  }
}

function stopLoop() {
  if (rafId) {
    cancelAnimationFrame(rafId);
    rafId = null;
  }
}

document.addEventListener('visibilitychange', function () {
  if (document.hidden) {
    stopLoop();
  } else {
    lastTime = null;
    startLoop();
  }
});

document.querySelectorAll('.logo-marquee').forEach(function (section) {
  var track = section.querySelector('.logo-marquee__track');
  if (!track) return;

  track.style.animation = 'none';

  var instance = {
    track: track,
    speed: parseFloat(section.dataset.speed) || 80,
    pos: 0,
    setWidth: 0,
    paused: false
  };

  function getOriginals() {
    return Array.from(track.children).filter(function (el) {
      return !el.classList.contains('logo-marquee__item--clone');
    });
  }

  function buildClones() {
    Array.from(track.children)
      .filter(function (el) { return el.classList.contains('logo-marquee__item--clone'); })
      .forEach(function (el) { el.remove(); });

    var originals = getOriginals();
    if (!originals.length) return;

    var minWidth = window.innerWidth * 2.5;
    while (track.scrollWidth < minWidth) {
      originals.forEach(function (item) {
        var clone = item.cloneNode(true);
        clone.classList.add('logo-marquee__item--clone');
        clone.setAttribute('aria-hidden', 'true');
        clone.removeAttribute('data-shopify-editor-block');
        track.appendChild(clone);
      });
    }
  }

  function measureSetWidth() {
    var originals = getOriginals();
    if (!originals.length) return 0;

    var total = 0;
    originals.forEach(function (el) { total += el.offsetWidth; });

    var gap = parseFloat(getComputedStyle(track).gap) || 0;
    total += gap * originals.length;

    return total;
  }

  if (section.dataset.pauseOnHover === 'true') {
    section.addEventListener('mouseenter', function () { instance.paused = true; });
    section.addEventListener('mouseleave', function () { instance.paused = false; });
  }

  function init() {
    buildClones();
    instance.setWidth = measureSetWidth();
    instance.pos = 0;
  }

  if (document.readyState === 'complete') {
    init();
  } else {
    window.addEventListener('load', init);
  }

  window.addEventListener('resize', init);

  marqueeInstances.push(instance);
});

startLoop();